import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import "./loading-tick.scss"

/**
 * Loading tick is a ported animation form the original onboarding loading screen.
 * 
 */
const baseClass = 'animated-success-loading-tick'

const LoadingTick = ({ animationDelayMs }) => {

  const [status, setStatus] = useState('active')

  useEffect(() => {
    const timeout = setTimeout(() => {
      setStatus('done')
    }, animationDelayMs)

    return () => clearTimeout(timeout)
  }, [status])

  return (
    <div className={`${baseClass} ${status}`}>
      <div className={`${baseClass}__container`}>
        <svg className={`${baseClass}__graphic`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
          <circle className="circle" vectorEffect="non-scaling-stroke" cx="50" cy="50" r="35" />
          <path className="tick" vectorEffect="non-scaling-stroke" d="M 34 35 L 50 55 L 90 20" />
        </svg>
      </div>
    </div>
  )
}
LoadingTick.propTypes = {
  animationDelayMs: PropTypes.number.isRequired 
}
LoadingTick.defaultProps = {
  animationDelayMs: 200
}

export default LoadingTick